export default __webpack_public_path__ + "static/media/inn-home-page.f8dca285.png";